export const topsSizeList = {
  S: {
    Slim: {
      Short: true,
      Regular: true,
      Long: false
    },
    'Dadletic™': {
      Short: false,
      Regular: true,
      Long: false
    },
    Straight: {
      Short: false,
      Regular: true,
      Long: false
    }
  },
  M: {
    Slim: {
      Short: true,
      Regular: true,
      Long: true
    },
    'Dadletic™': {
      Short: true,
      Regular: true,
      Long: true
    },
    Straight: {
      Short: true,
      Regular: true,
      Long: true
    }
  },
  'M+': {
    Slim: {
      Short: true,
      Regular: true,
      Long: true
    },
    'Dadletic™': {
      Short: true,
      Regular: true,
      Long: true
    },
    Straight: {
      Short: true,
      Regular: true,
      Long: true
    }
  },
  L: {
    Slim: {
      Short: false,
      Regular: true,
      Long: true
    },
    'Dadletic™': {
      Short: true,
      Regular: true,
      Long: true
    },
    Straight: {
      Short: true,
      Regular: true,
      Long: true
    }
  },
  'L+': {
    Slim: {
      Short: false,
      Regular: true,
      Long: true
    },
    'Dadletic™': {
      Short: true,
      Regular: true,
      Long: true
    },
    Straight: {
      Short: false,
      Regular: true,
      Long: true
    }
  },
  XL: {
    Slim: {
      Short: false,
      Regular: true,
      Long: true
    },
    'Dadletic™': {
      Short: true,
      Regular: true,
      Long: true
    },
    Straight: {
      Short: false,
      Regular: true,
      Long: true
    }
  },
  XXL: {
    Slim: {
      Short: false,
      Regular: true,
      Long: false
    },
    'Dadletic™': {
      Short: true,
      Regular: true,
      Long: true
    },
    Straight: {
      Short: false,
      Regular: true,
      Long: false
    }
  }
} as const
